import ROLES from '../constants/Roles';

const sanitise = ({id, ...rest}) => ({
    id: Number(id) || null,
    ...rest
});

const Auth = (function(currentUser) {
    return {
        identity: sanitise(currentUser),

        isLoggedIn: function() {
            return !!this.identity.id;
        },

        getCurrentUser: function() {
            return this.identity;
        },

        hasRole: function(ROLE) {
            return this.isLoggedIn() && this.identity.roles.some(function(userRole) { return userRole === ROLE; });
        },

        getRoles: function() {
            if (!this.isLoggedIn()) {
                return [];
            }

            return this.identity.roles;
        },

        isAdmin: function() {
            return this.hasRole(ROLES.ADMIN);
        },

        isManager: function() {
            return this.hasRole(ROLES.MANAGER);
        },

        canEdit: function(access) {
            if (!access) { return true; }
            if (!this.identity.accessGroup) { return false; }
            return (this.identity.accessGroup.left <= access.left && access.right <= this.identity.accessGroup.right);
        },

        isRoot: function() {
            if (!this.identity.accessGroup) { return false; }
            return (this.identity.accessGroup.left === 1);
        },

        isRootAdmin: function () {
            return (this.isAdmin() && this.isRoot());
        }
    }
});

export default Auth;
